
import Player from '@vimeo/player'

export async function createYoutubePlayer(element, youtubeId) {
  const youtubeApi = await loadVideoApi('https://www.youtube.com/iframe_api', 'YT')

  const api = {
    play: () => {},
    pause: () => {}
  }

  return new Promise((resolve) => {
    youtubeApi.ready(() => {
      // eslint-disable-next-line no-new
      new youtubeApi.Player(element, {
        videoId: youtubeId,
        width: 640,
        height: 390,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          origin: window.location.host
        },
        events: {
          onReady: (event) => {
            api.play = () => event.target.playVideo()
            api.pause = () => event.target.pauseVideo()
            resolve(api)
          }
        }
      })
    })
  })
}

export function createVimeoPlayer(element, videoId) {
  const api = {
    play: () => {}
  }
  const player = new Player(element, {
    id: videoId,
    dnt: true,
    maxwidth: 640,
    maxheight: 390
  })
  return new Promise(resolve => {
    player.on('loaded', async () => {
      api.play = () => player.play()
      api.pause = () => player.pause()
      resolve(api)
    })
  })
}

const loading = new Map()
export async function loadVideoApi(src, globalName) {
  const api = (window)[globalName]

  if(api) { return Promise.resolve(api) }

  const pending = loading.get(src)

  if(pending) { return pending }

  const promise = new Promise((resolve, reject) => {
    const scriptTag = document.createElement('script')
    scriptTag.src = src
    document.body.appendChild(scriptTag)
    scriptTag.onload = () => {
      resolve(window[globalName])
    }
    scriptTag.onerror = reject
  })
  loading.set(src, promise)

  return promise
}
